import React, { FC } from 'react';
import Footer from 'components/layout/footer';
import Header from 'components/layout/header';

const InfoLayout: FC = ({ children }) => {
  return (
    <div className="app app-info-layout">
      <Header />
      <div className="app-content">
        {children}
      </div>
      <Footer />
    </div>
  );
};

export default InfoLayout;